<template>
  <v-select
    class="combobox-role"
    color="primary"
    density="compact"
    variant="outlined"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SfSelect',
  inheritAttrs: false
})
</script>
